export default __webpack_public_path__ + "static/methodology-m-2742031a640b5d34bb0aff7175069eec.svg";